var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8535 7.56256C22.8535 6.69969 23.4932 6.00006 24.2821 6.00006H35.7107C36.4996 6.00006 37.1392 6.69969 37.1392 7.56256V13.8126C37.1392 14.6754 36.4996 15.3751 35.7107 15.3751H24.2821C23.4932 15.3751 22.8535 14.6754 22.8535 13.8126V7.56256Z",
    fill: "url(#paint0_radial_1591_47464)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1429 9.12506H20V16.4168C20 17.5675 20.8954 18.5001 22 18.5001H38C39.1046 18.5001 40 17.5675 40 16.4168V9.12506H42.8571C46.802 9.12506 50 12.6229 50 16.9376V48.1876C50 52.5022 46.802 56.0001 42.8571 56.0001H17.1429C13.198 56.0001 10 52.5022 10 48.1876V16.9376C10 12.6229 13.198 9.12506 17.1429 9.12506ZM30 27.8751C29.2111 27.8751 28.5714 28.5747 28.5714 29.4376C28.5714 30.3004 29.2111 31.0001 30 31.0001H41.4286C42.2175 31.0001 42.8571 30.3004 42.8571 29.4376C42.8571 28.5747 42.2175 27.8751 41.4286 27.8751H30ZM28.5714 41.9376C28.5714 41.0747 29.2111 40.3751 30 40.3751H35.7143C36.5032 40.3751 37.1429 41.0747 37.1429 41.9376C37.1429 42.8004 36.5032 43.5001 35.7143 43.5001H30C29.2111 43.5001 28.5714 42.8004 28.5714 41.9376ZM17.1429 29.4376C17.1429 26.8486 19.0616 24.7501 21.4286 24.7501C23.7956 24.7501 25.7143 26.8486 25.7143 29.4376C25.7143 32.0265 23.7956 34.1251 21.4286 34.1251C19.0616 34.1251 17.1429 32.0265 17.1429 29.4376ZM17.1429 41.9376C17.1429 39.3486 19.0616 37.2501 21.4286 37.2501C23.7956 37.2501 25.7143 39.3486 25.7143 41.9376C25.7143 44.5265 23.7956 46.6251 21.4286 46.6251C19.0616 46.6251 17.1429 44.5265 17.1429 41.9376Z",
    fill: "url(#paint1_radial_1591_47464)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1591_47464",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9964 12.9727) rotate(-90) scale(4.6875 7.14286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF416C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1591_47464",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30 43.9883) rotate(-90) scale(23.4375 20)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF416C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentList);
export default __webpack_public_path__ + "static/media/StudentList.870040e707033f6831c155158d0eb869.svg";
export { ForwardRef as ReactComponent };